export default function initExclusivityTags(): void {
    document.querySelectorAll<HTMLElement>( '[data-tag-exclusive]' ).forEach( ( tag: HTMLElement ): void => {
        if ( !tag.dataset.tagExclusive ) {
            return;
        }

        const pattern = new RegExp( tag.dataset.tagExclusive );

        const input: HTMLInputElement | null = tag.querySelector( 'input' );

        if ( !input ) {
            return;
        }

        input.addEventListener( 'change', ( event: Event ): void => {
            if ( !input.checked ) {
                return;
            }

            document.querySelectorAll<HTMLInputElement>( '[data-tag-exclusive] input' ).forEach( ( otherInput: HTMLInputElement ): void => {
                if ( otherInput.value !== input.value && pattern.test( otherInput.value ) ) {
                    otherInput.checked = false;
                }
            } );
        } );
    } );
}
